import { ClientModel } from '@models/client.model'
import { ChatReplyModel } from '@models/chat-reply.model'
import { ChatFileModel } from '@models/chat-file.model'

export class ChatModel {
    static COLLECTION_NAME = 'clientCommunication'

    _id?: any
    communicationId?: any
    communication?: ChatModel
    isPatientCreate?: boolean
    visitDate?: number
    clientId?: string
    clientName?: string
    content?: string
    doctorInCharge?: string
    staffInCharge?: string
    tags?: string[]
    privateTags?: string[]
    note?: string
    images?: string[] = []
    pdfs?: string[] = []
    video?: string[] = []
    next?: string
    type?: string
    doctor?: string
    staff?: string
    updateDate?: any
    updateTime?: number
    clinicReact?: number
    patientReact?: number

    client?: ClientModel

    replies?: ChatReplyModel[]
    lastReply?: ChatReplyModel
    createTime?: number
    file?: ChatFileModel
}



// WEBPACK FOOTER //
// ./src/models/chat.model.ts